
export const MASTER_DATA = {
  /* =========================
     PASSPORT TYPE
  ========================== */
 passport_type: [
  { label: "Ordinary Passport", value: "Ordinary Passport" },
  { label: "Official Passport", value: "Official Passport" },
  { label: "Diplomatic Passport", value: "Diplomatic Passport" },
  { label: "Service Passport", value: "Service Passport" },
  { label: "Special Passport", value: "Special Passport" },
],


  /* =========================
     GENDER
  ========================== */
  gender: [
    { label: "Male", value: "Male" },
    { label: "Female", value: "Female" },
    { label: "Transgender", value: "Other" },
  ],

  /* =========================
     RELIGION
  ========================== */
  religion: [
    { label: "Bahai", value: "BAHAI" },
    { label: "Buddhism", value: "BUDDHISM" },
    { label: "Christian", value: "CHRISTIAN" },
    { label: "Hindu", value: "HINDU" },
    { label: "Islam", value: "ISLAM" },
    { label: "Jainism", value: "JAINISM" },
    { label: "Judaism", value: "JUDAISM" },
    { label: "Parsi", value: "PARSI" },
    { label: "Sikh", value: "SIKH" },
    { label: "Zoroastrian", value: "ZOROASTRIAN" },
    { label: "Others", value: "OTHERS" },
  ],

  /* =========================
     EDUCATION
  ========================== */
  educational_qualification: [
    { label: "Below Matriculation", value: "BELOW MATRICULATION" },
    { label: "Matriculation", value: "MATRICULATION" },
    { label: "Higher Secondary", value: "HIGHER SECONDARY" },
    { label: "Graduate", value: "GRADUATE" },
    { label: "Post Graduate", value: "POST GRADUATE" },
    { label: "Professional", value: "PROFESSIONAL" },
    { label: "Illiterate", value: "ILLITERATE" },
    { label: "N/A (Being Minor)", value: "NA BEING MINOR" },
    { label: "Others", value: "OTHERS" },
  ],

  /* =========================
     NATIONALITY ACQUISITION
  ========================== */
  nationality_acquisition: [
    { label: "By Birth", value: "Birth" },
    { label: "By Naturalization", value: "By Naturalization" },
  ],

  /* =========================
     YES / NO (COMMON)
  ========================== */
  yes_no: [
    { label: "Yes", value: "YES" },
    { label: "No", value: "NO" },
  ],

  /* =========================
     LIVED 2 YEARS
     (⚠️ backend inverted logic)
  ========================== */
  lived_2_years: [
    { label: "Yes", value: "YES" },
    { label: "No", value: "NO" },
  ],

  /* =========================
     SAARC COUNTRIES
  ========================== */
  saarc_country: [
    { label: "Afghanistan", value: "AFGHANISTAN" },
    { label: "Bangladesh", value: "BANGLADESH" },
    { label: "Bhutan", value: "BHUTAN" },
    { label: "Maldives", value: "MALDIVES" },
    { label: "Nepal", value: "NEPAL" },
    { label: "Pakistan", value: "PAKISTAN" },
    { label: "Sri Lanka", value: "SRI LANKA" },
  ],
/* =========================
     MARITAL STATUS
  ========================== */

  marital_status: [
    { label: "Single", value: "Single" },
    { label: "Married", value: "Married" },
    { label: "Divorced", value: "Divorced" },
    { label: "Widowed", value: "Widowed" },
  ],
};
